export const Role = {
    SUPER_ADMIN: "super_admin",
    ADMIN: "admin",
    ARTIST: "artist",
    CONTENT_MODERATOR: "content_moderator",
};
